'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var Request$NimbusWeb = require("../../../utils/Request.bs.js");
var LoginResponse$NimbusWeb = require("./LoginResponse.bs.js");

function make(email, password) {
  var query = "\n    mutation login(\$email: String!, \$password: String!) {\n      login(email: \$email, password: \$password) {\n        ...TokenFragment\n      }\n    }\n    " + LoginResponse$NimbusWeb.fragment + "\n  ";
  var variables = [
    {
      key: "email",
      val: email
    },
    {
      key: "password",
      val: password
    }
  ];
  return Request$NimbusWeb.createBody(query, variables);
}

function data(json) {
  return {
          login: Json_decode.field("login", LoginResponse$NimbusWeb.Decode.token, json)
        };
}

function exec(json) {
  return {
          data: Json_decode.optional((function (param) {
                  return Json_decode.field("data", data, param);
                }), json)
        };
}

var Decode = {
  data: data,
  exec: exec
};

function normalize(payload) {
  var data = payload.data;
  if (data !== undefined) {
    return LoginResponse$NimbusWeb.normalize(data.login);
  } else {
    return {
            token: undefined,
            userType: undefined
          };
  }
}

var $$Response = {
  Decode: Decode,
  normalize: normalize
};

exports.make = make;
exports.$$Response = $$Response;
/* Request-NimbusWeb Not a pure module */
